<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
// eslint-disable-next-line camelcase

export default {
  name: 'App',
  data () {
    return {
    }
  },
  methods: {
    resize () {
      const width = window.innerWidth;
      // const height = window.innerHeight;
      document.getElementById('app').style.transform = `scale(${width / 1920}, ${width / 1920})`;
    }
  },
  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  }
}
</script>

<style lang="less">
     // 修改默认滚动条样式
   *::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

*:hover::-webkit-scrollbar-thumb {
  background: hsla(0, 0%, 53%, 0.4);
}

*:hover::-webkit-scrollbar-track {
  background: hsla(0, 0%, 53%, 0.1);
}
* {
  font-family: SourceHanSansCN-Regular;
}
  #app {
    width: 100%;
    height: 100%;
    transform-origin: 0 0;
  }
</style>
